import { devtools } from 'zustand/middleware'
import { create } from 'zustand'
import { IEventModalsStore } from '@proj-common/types'
import { SiteDeploymentType } from '@proj-common/utils'

export const useEventModalsStore = create<IEventModalsStore>()(devtools((set) => ({
    editIdeaModal: {
        isOpen: false,
    },
    setEditIdeaModal: (opts) => set(state => ({
        ...state,
        editIdeaModal: opts
    })),

    addIdeaModal: {
        isOpen: false,
    },
    setAddIdeaModal: (opts) => set(state => ({
        ...state,
        addIdeaModal: opts
    })),

    eventHelpModal: {
        isOpen: false,
        isDetailsTruncated: false
    },
    setEventHelpModal: (opts) => set(state => ({
        ...state,
        eventHelpModal: opts
    })),

    eventGetSupport: {
        isOpen: false
    },
    setEventGetSupportModal: (opts) => set(state => ({
        ...state,
        eventGetSupport: opts
    })),

    editEventDetailsModal: {
        isOpen: false,
    },
    setEditEventDetailsModal: (opts) => set(state => ({
        ...state,
        editEventDetailsModal: opts
    })),

    inviteLinkModal: {
        isOpen: false,
    },
    setInviteLinkModal: (opts) => set(state => ({
        ...state,
        inviteLinkModal: opts
    })),

    passphraseModal: {
        isOpen: false,
    },
    setPassphraseModal: (opts) => set(state => ({
        ...state,
        passphraseModal: opts
    })),

    nextStepOverlay: {
        isOpen: false,
    },
    setNextStepOverlay: (opts) => set(state => ({
        ...state,
        nextStepOverlay: opts
    })),

    // exportResultsModal
    exportResultsModal: {
        isOpen: false,
    },
    setExportResultsModal: (opts) => set(state => ({
        ...state,
        exportResultsModal: opts
    })),

    // eventPlanEditModal
    eventPlanEditModal: {
        isOpen: false,
    },
    setEventPlanEditModal: (opts) => set(state => ({
        ...state,
        eventPlanEditModal: opts
    })),

}), { name: 'Ideate Live', store: 'EventModalsStore', enabled: SiteDeploymentType() == 'development' }))